import React, { useEffect, useState, memo } from 'react';
import moment from 'moment';
import { useSearchParams } from 'react-router-dom';

import {
  Conditional,
  Space,
  Text,
  Button,
  Icon,
} from '@cashfree-intl/coherent';

import { formatStringForDisplay } from 'utils/common';
import { PLACEHOLDER_TEXT } from 'utils/constants';
import PaginatedTable from 'components/PaginatedTable';
import { formatColumns } from 'components/PaginatedTable/helpers';

import { HEADINGS, TDR_STATUS } from '../constants';
import { ITDRListProps } from '../types';

export function TDRList({
  displayTDRForm,
  enableLoader,
  getUpfrontTDR,
  disableLoader,
  isLoading,
}: ITDRListProps) {
  const [data, setData] = useState<any[]>([]);

  const [searchParams] = useSearchParams();
  const env = searchParams.get('env') || '';

  const formatTableData = (response: any) => {
    const result = response.map((obj: any) => ({
      ...obj,
      lastUpdatedOn: obj.lastUpdatedOn
        ? moment(obj.lastUpdatedOn).format('DD MMM YYYY')
        : PLACEHOLDER_TEXT,
      paymentMethod: formatStringForDisplay(obj.paymentMethod),
      tdrStatus: (
        <>
          <Conditional if={obj.tdrStatus === TDR_STATUS.ADDED}>
            <Text variant="b14" color="success">
              Active
            </Text>
          </Conditional>
          <Conditional if={obj.tdrStatus === TDR_STATUS.NOT_ADDED}>
            <Text variant="b14" color="bodyLight">
              TDR Not Added
            </Text>
          </Conditional>
        </>
      ),
      tdrCTA: (
        <Conditional if={obj.paymentMethod}>
          <Conditional if={obj.tdrStatus === TDR_STATUS.ADDED}>
            <Button
              className="p-0"
              link
              onClick={() => displayTDRForm(obj)}
              data-event-name="Table_Row_ManageTDR"
              data-ignore-inner-text="true"
              data-event-properties={JSON.stringify({
                row_id: obj.paymentMethod,
              })}
            >
              Manage TDR
            </Button>
          </Conditional>
          <Conditional if={obj.tdrStatus === TDR_STATUS.NOT_ADDED}>
            <Space
              alignItems="center"
              onClick={() => displayTDRForm(obj)}
              gap={0.5}
              className="pointer"
              data-event-name="Table_Row_AddUpfrontTDR"
              data-ignore-inner-text="true"
              data-event-properties={JSON.stringify({
                row_id: obj.paymentMethod,
              })}
            >
              <div>
                <Icon name="add" />
              </div>
              <Text color="primary" strong>
                Add Upfront TDR
              </Text>
            </Space>
          </Conditional>
        </Conditional>
      ),
    }));
    setData(result);
    disableLoader();
  };

  useEffect(() => {
    setTimeout(() => {
      enableLoader();
      getUpfrontTDR(formatTableData);
    }, 0);
  }, [env]);

  const formattedColumnId = formatColumns(HEADINGS);

  return (
    <div>
      <PaginatedTable
        data={data}
        tableHeading={formattedColumnId}
        isPaginated={false}
        fetching={isLoading}
      />
    </div>
  );
}

export default memo(TDRList);
